import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import classNames from 'classnames';
import { ModalHeaderWithCloseButton, SettingsMobileHeader, Tabs, Tab } from 'wix-rich-content-ui-components';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI, MEDIA_POPOVERS_TABS_NAMES_BI } from 'wix-rich-content-common';
import VideoUploadModal from './videoUploadModal.js';
import MediaURLInputModal from './NewMediaUrlInputModal.js';
import { videoButtonsTypes, VIDEO_TYPE } from '../types.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import 'prop-types';
import 'wix-rich-content-plugin-commons';
import './videoPluginService.js';
import 'lodash';

var css_248z = ".PG4aZ{height:100%;min-width:321px;position:relative}[dir] .PG4aZ{margin-top:-15px}.PG4aZ.Z9lrC{height:calc(100vh - 100px);overflow-x:hidden;overflow-y:auto;position:absolute;top:0;width:100%}[dir] .PG4aZ.Z9lrC{margin:0}[dir=ltr] .PG4aZ.Z9lrC{left:0}[dir=rtl] .PG4aZ.Z9lrC{right:0}.Yj6BV{position:relative;width:calc(100% + 40px)}[dir=ltr] .Yj6BV{margin-left:-20px}[dir=rtl] .Yj6BV{margin-right:-20px}.Z9lrC .Yj6BV{width:100%}[dir] .Z9lrC .Yj6BV{margin:0}.OY0nW{box-sizing:border-box}[dir] .OY0nW{padding:16px 20px 0}.OY0nW *,.OY0nW :after,.OY0nW :before{box-sizing:inherit}.OY0nW input{box-sizing:border-box}.Z9lrC .OY0nW{position:absolute;top:100px;width:100%}[dir] .Z9lrC .OY0nW{background-color:#fff;padding:20px}.OY0nW.V8jZv{height:154px;max-width:420px}.OY0nW :not(.Z9lrC).V8jZv{min-width:341px}.de02t{height:.1px;opacity:0;overflow:hidden;position:absolute;width:.1px;z-index:-1}.O2boN{display:inline-block;height:40px;width:108px}[dir] .O2boN{border:none}[dir=ltr] .O2boN{margin-left:12px;padding-left:24px;padding-right:24px}[dir=rtl] .O2boN{margin-right:12px;padding-left:24px;padding-right:24px}.Z9lrC .O2boN{flex-direction:column;gap:24px}[dir] .Z9lrC .O2boN{margin-bottom:0}.C4bXz{align-items:center;display:flex;font-size:16px;height:100%;justify-content:center;width:100%}[dir] .C4bXz{cursor:pointer}._95npy{position:absolute;top:50px;width:100%;z-index:2}[dir] ._95npy{background-color:#fff}";
var styles = {"video_modal_container":"PG4aZ","video_modal_mobile":"Z9lrC","video_modal_content":"Yj6BV","video_modal_tab":"OY0nW","video_upload_tab":"V8jZv","fileInput":"de02t","video_modal_add_button_inline":"O2boN","fileInputLabel":"C4bXz","video_tabs_headers":"_95npy"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const VideoInsertModal = (props) => {
  const {
    componentData: { isCustomVideo, src, type },
    helpers,
    t,
    theme,
    isMobile,
    closeModal,
    showCloseButton
  } = props;
  const videoTabs = { embed: t("VideoModal_Tabs_Embed"), upload: t("VideoModal_Tabs_Upload") };
  const initialUrl = isCustomVideo ? "" : src || "";
  const [activeTab, setActiveTab] = useState(isCustomVideo ? videoTabs.upload : videoTabs.embed);
  const [url, setUrl] = useState(initialUrl);
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const isSoundCloud = type === videoButtonsTypes.soundCloud;
  const getTabsBiButtonName = (tab) => tab === videoTabs.embed ? MEDIA_POPOVERS_TABS_NAMES_BI.embed : MEDIA_POPOVERS_TABS_NAMES_BI.upload;
  const { onPluginsPopOverTabSwitch, onPluginsPopOverClick } = helpers || {};
  const onTabSelected = (tab) => {
    activeTab !== tab && (onPluginsPopOverTabSwitch == null ? void 0 : onPluginsPopOverTabSwitch({
      pluginId: VIDEO_TYPE,
      buttonName: getTabsBiButtonName(tab)
    }));
    setActiveTab(tab);
  };
  const onUrlInputDoubleClick = () => setUrl("https://www.youtube.com/watch?v=ZVmHVzwOWro");
  const onConfirm = () => {
    onPluginsPopOverClick == null ? void 0 : onPluginsPopOverClick({
      pluginId: VIDEO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    if (url && ReactPlayer.canPlay(url)) {
      const { componentData, helpers: helpers2, onConfirm: onConfirm2, onReplace, updateVideoMetadata, experiments } = props;
      if (onConfirm2) {
        onConfirm2(__spreadProps(__spreadValues({}, componentData), { src: url, isCustomVideo: false }));
      } else {
        onReplace({ src: url, isCustomVideo: false });
      }
      if (helpers2 && helpers2.onVideoSelected) {
        const isTiptap = experiments.tiptapEditor.enabled;
        helpers2.onVideoSelected(
          url,
          (data) => isTiptap ? updateVideoMetadata(data.oembed) : onReplace({ metadata: __spreadValues({}, data) })
        );
      }
      closeModal == null ? void 0 : closeModal();
    } else {
      setSubmittedInvalidUrl(true);
    }
  };
  const dataHook = isSoundCloud ? "soundCloudUploadModal" : "videoMediaUrlModal";
  const title = isSoundCloud ? isMobile ? t("SoundCloudUploadModal_Header_Mobile") : t("SoundCloudUploadModal_Header") : null;
  const renderMediaUrlInputModal = () => {
    return /* @__PURE__ */ React.createElement(
      MediaURLInputModal,
      __spreadProps(__spreadValues({}, props), {
        onConfirm,
        url,
        setUrl,
        submittedInvalidUrl,
        withMobileHeader: isSoundCloud,
        dataHook,
        title: isSoundCloud && title,
        saveLabel: isSoundCloud ? t("Embed_Add_Button_Label") : t("VideoModal_Embed_ButtonText"),
        subTitle: !isSoundCloud && t("VideoModal_Embed_Title"),
        onDoubleClick: onUrlInputDoubleClick
      })
    );
  };
  return isSoundCloud ? renderMediaUrlInputModal() : /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.video_modal_container, {
        [styles.video_modal_mobile]: isMobile
      })
    },
    showCloseButton && /* @__PURE__ */ React.createElement(ModalHeaderWithCloseButton, { title: t("Video_Modal_Header_Title"), closeModal }),
    /* @__PURE__ */ React.createElement("div", { className: styles.video_modal_content }, isMobile && /* @__PURE__ */ React.createElement(
      SettingsMobileHeader,
      {
        theme,
        onSave: onConfirm,
        onCancel: closeModal,
        t,
        title: t("VideoModal_MobileHeader"),
        useNewSettingsUi: true,
        showSaveBtn: false
      }
    ), /* @__PURE__ */ React.createElement(
      Tabs,
      {
        value: activeTab,
        onTabSelected,
        className: styles.video_modal_tabs_header,
        theme,
        headersStyle: isMobile && styles.video_tabs_headers
      },
      /* @__PURE__ */ React.createElement(Tab, { label: videoTabs.embed, value: videoTabs.embed, theme }, /* @__PURE__ */ React.createElement("div", { className: styles.video_modal_tab }, renderMediaUrlInputModal())),
      /* @__PURE__ */ React.createElement(Tab, { label: videoTabs.upload, value: videoTabs.upload, theme }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles.video_modal_tab, styles.video_upload_tab) }, /* @__PURE__ */ React.createElement(VideoUploadModal, __spreadValues({}, props))))
    ))
  );
};

export { VideoInsertModal as default };
//# sourceMappingURL=NewVideoInsertModal.js.map
